
import { Placement } from '@post-office/placements-frontend/rovo-chat-input-full-page';
export default Placement;
